import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';

import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

import {PageRequest} from '../../../../core';
import {AuthUser, TokenService} from '../../../../core/auth';

import {User, UserGroup, UserGroupResponse} from '../../../../core/models';
import {UserGroupService} from '../../../../core/services';
import {BreadcrumbService} from '../../../../breadcrumb.service';
import {DataTable} from 'primeng/datatable';
import {ConfirmationService} from 'primeng/api';

@Component({
  selector: 'app-user-group-list',
  templateUrl: './user-group-list.page.html',
  styleUrls: ['./user-group-list.page.scss']
})
export class UserGroupListPage implements OnInit {
  @Input() query = new PageRequest();
  private searchTerms = new Subject<PageRequest>();
  userGroupResponse = new UserGroupResponse();
  @ViewChild('dt') dt: DataTable;
  loading = true;
  authUser: AuthUser = this.token.whoAmI();

  constructor(
    private router: Router,
    private token: TokenService,
    private userGroupService: UserGroupService,
    private breadcrumbService: BreadcrumbService,
    private confirmationService: ConfirmationService
  ) {
    this.breadcrumbService.setItems([
      {label: 'admin', routerLink: ['/admin']},
      {label: 'group'},
      {label: 'list'}
    ]);
  }

  ngOnInit() {
    this.searchTerms.pipe(debounceTime(500)).subscribe(
      (query) => {
        this.getUserGroups(query);
      }
    );
  }

  navigateToCreateNew() {
    this.router.navigate(['/admin', 'group']);
  }

  search(query: PageRequest): void {
    this.searchTerms.next(query);
  }

  paginate(event) {

    if (event.sortField !== undefined && event.sortField == 'userCount') {
      if (event.sortOrder == 1) {
        this.userGroupResponse.content.sort(function (a, b) {
          return a.userCount - b.userCount;
        });
      } else {
        this.userGroupResponse.content.sort(function (a, b) {
          return b.userCount - a.userCount;
        });
      }
      return;
    }

    this.query.page = (event.first / event.rows) + 1;
    this.query.sortField = event.sortField !== undefined ? event.sortField : 'name';
    this.query.sortDir = this.query.getSortDir(event.sortOrder);

    this.getUserGroups(this.query);
  }

  getUserGroups(query?: PageRequest): void {
    this.loading = true;
    this.userGroupService.search(query)
      .subscribe(
        (data) => {
          this.userGroupResponse = data;
          delete (this.loading);
        },
        (error) => {
          delete (this.loading);
        });
  }

  confirmDelete(userGroup: UserGroup) {
    this.confirmationService.confirm({
      header: 'Delete User Group',
      message: 'By clicking the button below you will delete this user group',
      rejectVisible: false,
      acceptLabel: ' Proceed',
      accept: () => {
        this.delete(userGroup);
      }
    });
  }

  delete(userGroup: UserGroup): void {
    this.userGroupService.delete(userGroup.id).subscribe((data) => {
          this.getUserGroups(this.query);
        },
        (error) => {
          this.getUserGroups(this.query);
        });
    // this.reload(2000);
  }


  private reload(timeout: number): void {
    window.setTimeout(() => {
      this.getUserGroups(this.query);
    }, timeout);
  }
}
